import {
  ArrowRight,
  Code,
  Palette,
  Zap,
  Star,
  Users,
  Mail,
  Phone,
  CheckCircle,
} from "lucide-react";
import logoHorizontal from "../assets/logo-horizontal.svg";
import logoHorizontalBranco from "../assets/logo-horizontal-branco.svg";
import computador from "../assets/computador.jpg";
import Contato from "../components/Contato";

export default function Home() {
  const colors = {
    black: "#000000",
    white: "#FFFFFF",
    blue1: "#5ABDD6",
    blue2: "#3C9ED4",
    blue3: "#3774B8",
    purple1: "#4C4294",
    purple2: "#5F328A",
    purple3: "#873289",
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: colors.white }}>
      {/* Header */}
      <header
        className="sticky top-0 z-50 backdrop-blur-sm border-b"
        style={{
          backgroundColor: "rgba(255,255,255,0.95)",
          borderColor: "#e5e7eb",
        }}
      >
        <div className="container mx-auto px-4 py-4">
          <nav className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <img src={logoHorizontal} alt="Logo BrilhanTI" className="h-12" />
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#empresa"
                className="text-gray-600 hover:opacity-80 transition-opacity"
              >
                Empresa
              </a>
              <a
                href="#tecnologias"
                className="text-gray-600 hover:opacity-80 transition-opacity"
              >
                Tecnologias
              </a>
              <a
                href="#servicos"
                className="text-gray-600 hover:opacity-80 transition-opacity"
              >
                Serviços
              </a>
              <button
                className="px-6 py-2 rounded hover:opacity-90 transition-opacity"
                style={{ backgroundColor: colors.purple3, color: colors.white }}
              >
                <a href="http://wa.me/5588996488674">Peça um orçamento</a>
              </button>
            </div>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section
        className="relative overflow-hidden py-20"
        style={{
          background: `linear-gradient(to bottom right, rgba(90,189,214,0.05), ${colors.white}, rgba(135,50,137,0.05))`,
        }}
      >
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="space-y-4">
                <span
                  className="inline-block px-4 py-2 rounded-full text-sm font-medium"
                  style={{
                    backgroundColor: "rgba(55,116,184,0.1)",
                    color: colors.blue3,
                    border: "1px solid rgba(55,116,184,0.2)",
                  }}
                >
                  ✨ Especialidade em entrega e qualidade
                </span>
                <h1
                  className="text-4xl md:text-6xl font-bold leading-tight"
                  style={{ color: colors.black }}
                >
                  Tenha seu site online{" "}
                  <span style={{ color: colors.blue3 }}>rápido</span>, e com{" "}
                  <span style={{ color: colors.purple3 }}>
                    melhor qualidade
                  </span>
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed">
                  Somos especialistas em desenvolvimento de sites e sistemas
                  para sua empresa. Entrega rápida e com a melhor qualidade.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  className="px-6 py-3 rounded text-lg hover:opacity-90 transition-opacity flex items-center justify-center"
                  style={{
                    backgroundColor: colors.purple3,
                    color: colors.white,
                  }}
                  onClick={() => {
                    const section = document.getElementById("servicos");
                    if (section) {
                      section.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                >
                  Conheça nossos serviços
                  <ArrowRight className="ml-2 h-4 w-4" />
                </button>
                <button
                  className="px-6 py-3 rounded text-lg hover:opacity-80 transition-opacity"
                  style={{
                    borderColor: colors.blue3,
                    color: colors.blue3,
                    backgroundColor: "transparent",
                    border: `2px solid ${colors.blue3}`,
                  }}
                >
                  Ver portfólio
                </button>
              </div>
              {/* <div className="flex items-center space-x-8 pt-4">
                <div className="text-center">
                  <div className="text-2xl font-bold" style={{ color: colors.blue3 }}>50+</div>
                  <div className="text-sm text-gray-600">Projetos entregues</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold" style={{ color: colors.blue3 }}>100%</div>
                  <div className="text-sm text-gray-600">Clientes satisfeitos</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold" style={{ color: colors.blue3 }}>24h</div>
                  <div className="text-sm text-gray-600">Tempo de resposta</div>
                </div>
              </div> */}
            </div>
            <div className="relative">
              <img
                src={computador}
                alt="Computador"
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="empresa" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2
              className="text-3xl md:text-4xl font-bold mb-4"
              style={{ color: colors.black }}
            >
              Por que escolher a{" "}
              <span style={{ color: colors.blue3 }}>BrilhanTI</span>?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Transformamos ideias em realidade digital com excelência técnica e
              criatividade
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 p-8 text-center">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 hover:opacity-80 transition-opacity"
                style={{ backgroundColor: "rgba(135,50,137,0.1)" }}
              >
                <Zap className="h-8 w-8" style={{ color: colors.purple3 }} />
              </div>
              <h3
                className="text-xl font-bold mb-4"
                style={{ color: colors.black }}
              >
                Agilidade
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Garantimos os melhores tempos de entrega e de resposta para os
                nossos clientes.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 p-8 text-center">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 hover:opacity-80 transition-opacity"
                style={{ backgroundColor: "rgba(55,116,184,0.1)" }}
              >
                <Star className="h-8 w-8" style={{ color: colors.blue3 }} />
              </div>
              <h3
                className="text-xl font-bold mb-4"
                style={{ color: colors.black }}
              >
                Qualidade
              </h3>
              <p className="text-gray-600 leading-relaxed">
                A melhor qualidade e desempenho juntos em um site feito para
                você, no seu estilo.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 p-8 text-center">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 hover:opacity-80 transition-opacity"
                style={{ backgroundColor: "rgba(90,189,214,0.1)" }}
              >
                <Palette className="h-8 w-8" style={{ color: colors.blue1 }} />
              </div>
              <h3
                className="text-xl font-bold mb-4"
                style={{ color: colors.black }}
              >
                Criatividade
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Sites criativos com melhores técnicas de design para fazer seu
                projeto decolar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section
        id="servicos"
        className="py-20"
        style={{ backgroundColor: colors.white }}
      >
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2
              className="text-3xl md:text-4xl font-bold mb-4"
              style={{ color: colors.black }}
            >
              Nossos <span style={{ color: colors.blue3 }}>Serviços</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Desenvolvimento inovador com design excepcional e gestão
              profissional
            </p>
          </div>
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
              <div
                className="h-48 flex items-center justify-center"
                style={{
                  background: `linear-gradient(to bottom right, rgba(55,116,184,0.1), rgba(135,50,137,0.1))`,
                }}
              >
                <Code
                  className="h-16 w-16 hover:scale-110 transition-transform"
                  style={{ color: colors.blue3 }}
                />
              </div>
              <div className="p-6">
                <h3
                  className="text-xl font-bold mb-3"
                  style={{ color: colors.black }}
                >
                  Desenvolvimento Web
                </h3>
                <p className="text-gray-600 mb-4">
                  Construindo a sua presença digital, uma linha de código de
                  cada vez.
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <CheckCircle
                      className="h-4 w-4 mr-2"
                      style={{ color: colors.purple3 }}
                    />
                    Sites responsivos e modernos
                  </li>
                  <li className="flex items-center">
                    <CheckCircle
                      className="h-4 w-4 mr-2"
                      style={{ color: colors.purple3 }}
                    />
                    E-commerce completo
                  </li>
                  <li className="flex items-center">
                    <CheckCircle
                      className="h-4 w-4 mr-2"
                      style={{ color: colors.purple3 }}
                    />
                    Sistemas web personalizados
                  </li>
                </ul>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
              <div
                className="h-48 flex items-center justify-center"
                style={{
                  background: `linear-gradient(to bottom right, rgba(135,50,137,0.1), rgba(55,116,184,0.1))`,
                }}
              >
                <Users
                  className="h-16 w-16 hover:scale-110 transition-transform"
                  style={{ color: colors.purple3 }}
                />
              </div>
              <div className="p-6">
                <h3
                  className="text-xl font-bold mb-3"
                  style={{ color: colors.black }}
                >
                  Gestão de Sites
                </h3>
                <p className="text-gray-600 mb-4">
                  Otimizando a sua presença online, passo a passo.
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <CheckCircle
                      className="h-4 w-4 mr-2"
                      style={{ color: colors.purple3 }}
                    />
                    Manutenção e atualizações
                  </li>
                  <li className="flex items-center">
                    <CheckCircle
                      className="h-4 w-4 mr-2"
                      style={{ color: colors.purple3 }}
                    />
                    Otimização de performance
                  </li>
                  <li className="flex items-center">
                    <CheckCircle
                      className="h-4 w-4 mr-2"
                      style={{ color: colors.purple3 }}
                    />
                    Suporte técnico 24/7
                  </li>
                </ul>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
              <div
                className="h-48 flex items-center justify-center"
                style={{
                  background: `linear-gradient(to bottom right, rgba(90,189,214,0.1), rgba(76,66,148,0.1))`,
                }}
              >
                <Palette
                  className="h-16 w-16 hover:scale-110 transition-transform"
                  style={{ color: colors.blue1 }}
                />
              </div>
              <div className="p-6">
                <h3
                  className="text-xl font-bold mb-3"
                  style={{ color: colors.black }}
                >
                  Design Personalizado
                </h3>
                <p className="text-gray-600 mb-4">
                  Transformando ideias em experiências visuais extraordinárias.
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <CheckCircle
                      className="h-4 w-4 mr-2"
                      style={{ color: colors.purple3 }}
                    />
                    UI/UX Design profissional
                  </li>
                  <li className="flex items-center">
                    <CheckCircle
                      className="h-4 w-4 mr-2"
                      style={{ color: colors.purple3 }}
                    />
                    Identidade visual completa
                  </li>
                  <li className="flex items-center">
                    <CheckCircle
                      className="h-4 w-4 mr-2"
                      style={{ color: colors.purple3 }}
                    />
                    Prototipagem interativa
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        className="py-20"
        style={{
          background: `linear-gradient(to right, ${colors.blue3}, ${colors.purple3})`,
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto">
            <h2
              className="text-3xl md:text-4xl font-bold mb-6"
              style={{ color: colors.white }}
            >
              Vamos discutir algo incrível juntos!
            </h2>
            <p
              className="text-xl mb-8"
              style={{ color: "rgba(255,255,255,0.9)" }}
            >
              Pronto para transformar sua ideia em realidade digital? Entre em
              contato e vamos criar algo extraordinário.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                className="px-6 py-3 rounded text-lg hover:opacity-90 transition-opacity flex items-center justify-center"
                style={{ backgroundColor: colors.white, color: colors.blue3 }}
                onClick={() =>
                  (window.location.href =
                    "mailto:laryssa.brilhante@hotmail.com")
                }
              >
                <Mail className="mr-2 h-5 w-5" />
                Solicitar Orçamento Gratuito
                <ArrowRight className="ml-2 h-4 w-4" />
              </button>
              <button
                className="px-6 py-3 rounded text-lg hover:opacity-80 transition-opacity flex items-center justify-center"
                style={{
                  borderColor: colors.white,
                  color: colors.white,
                  backgroundColor: "transparent",
                  border: `2px solid ${colors.white}`,
                }}
              >
                <Phone className="mr-2 h-5 w-5" />
                <a href="http://wa.me/5588996488674">(88) 99648-8674</a>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-20 bg-gray-50">
        <Contato />
      </section>

      {/* Footer */}
      <footer
        className="py-12"
        style={{ backgroundColor: colors.black, color: colors.white }}
      >
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img
                  src={logoHorizontalBranco}
                  alt="Logo BrilhanTI"
                  className="h-12"
                />
              </div>
              <p className="text-gray-400 mb-4">
                Especialistas em desenvolvimento web com foco em qualidade e
                agilidade.
              </p>
              <div className="space-y-2">
                <p className="text-gray-400">
                  <Mail className="inline h-4 w-4 mr-2" />
                  <a href="mailto:laryssa.brilhante@hotmail.com">
                    laryssa.brilhante@hotmail.com
                  </a>
                </p>
                <p className="text-gray-400">
                  <Phone className="inline h-4 w-4 mr-2" />
                  <a href="http://wa.me/5588996488674">(88) 99648-8674</a>
                </p>
              </div>
            </div>
            <div>
              <h3 className="font-semibold mb-4">Links Rápidos</h3>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a
                    href="#empresa"
                    className="hover:opacity-80 transition-opacity"
                  >
                    Empresa
                  </a>
                </li>
                <li>
                  <a
                    href="#tecnologias"
                    className="hover:opacity-80 transition-opacity"
                  >
                    Tecnologias
                  </a>
                </li>
                <li>
                  <a
                    href="#servicos"
                    className="hover:opacity-80 transition-opacity"
                  >
                    Serviços
                  </a>
                </li>
                <li>
                  <a
                    href="#contato"
                    className="hover:opacity-80 transition-opacity"
                  >
                    Contato
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-4">Serviços</h3>
              <ul className="space-y-2 text-gray-400">
                <li>Desenvolvimento Web</li>
                <li>UX/UI Design</li>
                <li>Gestão de Sites</li>
                <li>E-commerce</li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-4">Contate-nos</h3>
              <button
                className="w-full py-2 px-4 rounded hover:opacity-90 transition-opacity"
                style={{ backgroundColor: colors.blue3, color: colors.white }}
              >
                Enviar Mensagem
              </button>
            </div>
          </div>
          <div
            className="border-t mt-8 pt-8 text-center text-gray-400"
            style={{ borderColor: "#1f2937" }}
          >
            <p>© 2025 BrilhanTI. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
